import logoMenu from '../../assets/pictures/logo-2024.png';
import { useContext, useEffect, useState } from 'react';

import { AuthContext } from '../../contexts/authContext';
import { Navigate, useNavigate } from 'react-router-dom';


export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({
    email: '',
    password: '',
    form: '',
  });
  const [loading, setLoading] = useState(false);  
  const { signIn, isAuthenticated } = useContext(AuthContext);
  
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/painel/dashboard');
    }
  }, [isAuthenticated, navigate]);

   // Função para validar email
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // Função para validar senha (mínimo 6 caracteres)
  const validatePassword = (password) => {
    return password.length >= 6;
  };

  // Validação do formulário completo
  const validateForm = () => {
    let valid = true;
    const newErrors = {
      email: '',
      password: '',
      form: ''
    };

    // Validação do email
    if (!email) {
      newErrors.email = 'Email é obrigatório';
      valid = false;
    } else if (!validateEmail(email)) {
      newErrors.email = 'Por favor, insira um email válido';
      valid = false;
    }

    // Validação da senha
    if (!password) {
      newErrors.password = 'Senha é obrigatória';
      valid = false;
    } else if (!validatePassword(password)) {
      newErrors.password = 'A senha deve ter pelo menos 6 caracteres';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  async function handlleLogin(e){
    e.preventDefault();

    if(!validateForm()) return;

    try {
      setLoading(true);

      const loginSuccess = await signIn({ email, password });
      if (loginSuccess) {
        navigate('/painel/dashboard');
        console.log('Login bem-sucedido');

        setLoading(false)
      }
    } catch (error) {
      setErrors({
        ...errors,
        form: 'Erro ao fazer login. Por favor, verifique suas credenciais e tente novamente.'
      })
    }finally {
      setLoading(false);
    }

    if(isAuthenticated){
      return <Navigate to="/painel/dashboard" replace={true} />
    }
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-4">
      <form onSubmit={handlleLogin} className="w-full max-w-md bg-white p-8 rounded shadow-md">
        <picture className="mb-8 flex justify-center">
          <a href='/'>
            <img src={logoMenu} alt="logo" className='w-48' />
          </a>
        </picture>
        <div className="mb-4">
          <h2 className="text-2xl text-gray-600 font-medium mb-6 text-center">acesso administrador</h2>
          {errors.form && (
            <div className="mb-4 p-2 bg-red-100 text-red-700 text-sm rounded">
              {errors.form}
            </div>
          )}
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => {setEmail(e.target.value); setErrors({ ...errors, email: '', form: '' })}}
            className={`w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 ${errors.email} ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'}`}
            placeholder="digite seu e-mail"
            required
            />
            {errors.email && (
              <p className="text-red-600 text-sm">{errors.email}</p>
            )}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 ${
              errors.password ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
            }`}
            placeholder="**********"
            required
          />
          {errors.password && (
            <p className="mt-1 text-sm text-red-600">{errors.password}</p>
          )}
        </div>
        <button
          type="submit"
          disabled={loading}
          className={`w-full ${
            loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-gray-600 hover:bg-gray-700'
          } text-white py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors`}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Processando...
            </span>
          ) : (
            'Acessar'
          )}
        </button>
        <p className="text-sm text-center text-gray-600 p-6">
          Acessar como colaborador? <a href="/painel/sign-in" className="text-blue-600 hover:underline">login</a>
        </p>
      </form>
    </div>
  )
}